import type { Hearing } from "@/lib/public-hearings/types";

import { DC_BYLAW_NOTE, POLICY_NOTE } from "./constants";

// Plain-language qualifier line shown under the zoning-transform
// dl when the change isn't a straightforward upzone:
//   - statutory plan amendment (no district codes either side)
//   - DC bylaw amendment (DC → DC)
// Returns null for upzones (the dl is self-explanatory).
export function derivePolicyNote(h: Hearing): string | null {
  const isPolicy =
    h.fromDistricts.length === 0 && h.toDistricts.length === 0;
  if (isPolicy) return POLICY_NOTE;

  const isDc =
    h.toDistricts.length === 1 && h.toDistricts[0]?.toUpperCase() === "DC";
  if (
    isDc &&
    h.fromDistricts.length === 1 &&
    h.fromDistricts[0]?.toUpperCase() === "DC"
  ) {
    return DC_BYLAW_NOTE;
  }

  return null;
}
